import {AbstractFileSettleFormComponent} from '../file-settle-dialog/abstract-file-settle-form.component';
import {Directive, Input, OnInit} from '@angular/core';
import {FilePrepareCompletionFileTypeDto} from '|api/document';
import {IczOption} from '@icz/angular-form-elements';
import {IczOnChanges, IczSimpleChanges} from '@icz/angular-essentials';
import {EntityClassSelectorUsage} from '|shared';
import {EntityClassDto, EntityClassType} from '|api/commons';
import {startWith} from 'rxjs/operators';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Directive()
export class AbstractFileCloseForm extends AbstractFileSettleFormComponent implements IczOnChanges, OnInit {
  @Input()
  availableEntityClasses: Nullable<EntityClassDto[]>;
  @Input()
  availableFileTypes?: Nullable<FilePrepareCompletionFileTypeDto[]>;

  fileTypeOptions: IczOption[] = [];

  closeDate = new Date();

  override ngOnInit() {
    super.ngOnInit();
    this.form.get('closeDate')!.valueChanges.pipe(startWith(this.form.get('closeDate')!.value), takeUntilDestroyed(this.destroyRef)).subscribe(value => {
      this.closeDate = new Date(value);
    });
  }

  ngOnChanges(changes: IczSimpleChanges<this>) {
    if (changes?.availableFileTypes?.currentValue) {
      this.fileTypeOptions = this.availableFileTypes!.map(ft => {return {value: ft.id!, label: ft.label!};});
    }
  }

  protected readonly EntityClassType = EntityClassType;
  protected readonly EntityClassSelectorUsage = EntityClassSelectorUsage;
}
